import React, {useCallback, useState} from "react";
import "./index.scss";
import {object} from "prop-types";
import {connect} from "react-redux";
import {__} from "services/i18n";
import moment, {ISO_8601} from "moment";
import {historyObject} from "historyObject";
import {Icon} from "features/components/icon";
import Title from "features/components/title";
import {withToastManager} from "react-toast-notifications";
import Text from "features/components/text";
import {favoriteEventErrorSelector} from "store/reducer/event/favorite/selectors";
import {favoriteEventStart} from "store/reducer/event/favorite/reducer";

/* istanbul ignore next */
const mapStateToProps = state => ({
    error: favoriteEventErrorSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    favoriteEventStart
};


export const EventCard = (props) => {
    const {event, error} = props;
    const {favoriteEventStart} = props;

    const [favorite, setFavorite] = useState(event.favorite);
    const toggleFavorite = useCallback((ev) => {
        setFavorite(!favorite);
        favoriteEventStart({id: event.id, favorite: !favorite});
        ev.preventDefault();
        ev.stopPropagation();
    }, [favorite, favoriteEventStart, event]);

    React.useEffect(() => {
        setFavorite(event.favorite);
    }, [event]);

    React.useEffect(() => {
        if(!error.inError) return;
        props.toastManager.add(__(error.error), { appearance: 'error', id: 'favorite-video-fail' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    const navigateToDetail = useCallback(() => {
        historyObject.push(`/event/${event.id}`);
    }, [event.id]);


    return <div className="event-card" onClick={navigateToDetail}>
        <img src={event.image} alt="event banner" />
        <div className="favorite-btn" onClick={toggleFavorite}>
            <Icon>{favorite ? "heart-fill": "heart"}</Icon>
        </div>
        <div className="flags">
            {event.requires_payment && <div className="paid">
                <Icon>lock</Icon>
                <Title size={14}>€ {event.cost}</Title>
            </div>}
        </div>
        <div className={"event-content"}>
            <Icon>calendar</Icon>
            <div>
                <div className="categories">{event.categories.map(i => <Title size={12} key={i}>{i}</Title>)}</div>
                <Title size={20}>{event.title}</Title>
                <Text size={16}>{moment(event.start_date, ISO_8601).format("D MMMM")} | {event.category} | {__(`common.event-type.${event.type}`)}</Text>
            </div>
        </div>
    </div>
};
EventCard.propTypes = {
    event: object.isRequired
}
export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(EventCard));